module.exports = __webpack_public_path__ + "static/media/sautidb3.0fdf645c.png";